import { connect } from "react-redux";
import {default as FilmReleaseModalV} from "./FilmReleaseModal";
import {default as FilmCardViewV}  from "./FilmCardView";
import {actions} from "./logic/filmFormActions";

export const FilmReleaseModal =FilmReleaseModalV;


export const FilmCardView = connect((state) => ({
    filmReleaseFormOpen: state.filmReleaseForm.open,
}),
(dispatch) => ({
    toggleFilmReleaseForm: (editing,id) => dispatch(actions.TOGGLE_FILM_RELEASE_FORM.send({editing,id})),
}))(FilmCardViewV);